
import React from 'react';
import { Copyright } from '@/components/index-page/footer/Copyright';
import { motion } from 'framer-motion';

const AdminFooter: React.FC = () => {
  return (
    <motion.footer 
      className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-3 md:py-4 mt-6 rounded-xl shadow-md overflow-hidden"
      whileHover={{ 
        boxShadow: "0 10px 30px rgba(59, 130, 246, 0.3)"
      }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto px-3 md:px-4 flex justify-center items-center">
        <Copyright />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-blue-400/10 to-indigo-400/10"></div>
    </motion.footer>
  );
};

export default AdminFooter;
